module.exports = "<h2 style=\"text-align: center;\">Loading...</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/lxp-course-landing/lxp-course-landing.component.html
// module id = 901
// module chunks = 0